import * as React from 'react';
import s from './suggestions.scss';
import Search from 'wix-ui-icons-common/Search';
import { composer } from '../../../../component-decorators/composer';
import { Text } from 'wix-style-react';
import { SuggestionType } from '../../../../types/common/marketplace';
export var Suggestion = composer()
    .withTranslation()
    .compose(function (_a) {
    var suggestionKey = _a.suggestionKey, value = _a.value, onClick = _a.onClick, suggestionType = _a.suggestionType, icon = _a.icon, teaser = _a.teaser, index = _a.index, selected = _a.selected, addSelected = _a.addSelected, t = _a.t;
    var onMouseEnter = function () {
        addSelected && addSelected(index);
    };
    var onMouseLeave = function () {
        addSelected && addSelected(null);
    };
    return (React.createElement(React.Fragment, null,
        (suggestionType === SuggestionType.NONE_TYPE ||
            suggestionType === SuggestionType.SEARCH) && (React.createElement("div", { tabIndex: 0, "data-testid": 'suggestion-default-popular', className: (suggestionType === SuggestionType.NONE_TYPE
                ? s.defaultSuggestionContainer
                : s.popularSuggestionContainer) + " suggestion " + (selected ? 'selected' : ''), onClick: function (e) {
                onClick(e, {
                    suggestionKey: suggestionKey,
                    value: value,
                    onClick: onClick,
                    suggestionType: suggestionType,
                    icon: icon,
                    teaser: teaser,
                    index: index,
                    selected: selected,
                });
            }, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, style: selected
                ? suggestionType === SuggestionType.NONE_TYPE
                    ? { backgroundColor: '#eaf7ff' }
                    : { backgroundColor: '#daeffe' }
                : { backgroundColor: 'transparent' } },
            React.createElement(Search, { style: { color: '#3899ec', width: '24px', height: '24px' } }),
            React.createElement("div", { className: s.defaultSuggestionButton },
                React.createElement(Text, { size: 'small', weight: 'bold', skin: 'standard', "data-testid": "suggestion-" + suggestionKey }, suggestionType === SuggestionType.NONE_TYPE
                    ? t(value)
                    : value)))),
        (suggestionType === SuggestionType.APP ||
            suggestionType === SuggestionType.CATEGORY) && (React.createElement("div", { tabIndex: 0, "data-testid": 'suggestion-apps-categories', className: s.suggestionContainer + " suggestion " + (selected ? 'selected' : ''), onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, style: selected
                ? { backgroundColor: '#daeffe' }
                : { backgroundColor: 'transparent' } },
            React.createElement("img", { src: icon, className: s.suggestionIcon, "data-testid": 'suggestion-icon' }),
            React.createElement("div", { className: s.textContainer },
                React.createElement(Text, { weight: 'bold', size: 'small', skin: 'standard', className: s.suggestionButton, "data-testid": "suggestion-" + suggestionKey }, value),
                suggestionType === SuggestionType.APP && (React.createElement(Text, { size: 'small', className: s.suggestionButton, "data-testid": 'suggestion-teaser', skin: 'standard', secondary: true }, !teaser || teaser.length <= 50
                    ? teaser
                    : teaser.substring(0, 50) + "...")))))));
});
//# sourceMappingURL=suggestion.js.map